"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainTitle = exports.expandClickZone = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var colour = _feBrary.variables.colour,
  font = _feBrary.variables.font,
  global = _feBrary.variables.global;
var mainTitle = exports.mainTitle = /*#__PURE__*/(0, _core.css)("margin:0 0 14px;color:", colour.neutral700, ";font-family:", font.headingFontFamily, ";font-size:20px;font-weight:600;line-height:1.2;text-align:left;");
var expandClickZone = exports.expandClickZone = /*#__PURE__*/(0, _core.css)(":before{position:absolute;top:0;bottom:0;left:0;right:0;content:'';z-index:", global.layerOverlay, ";}");